// extracted by mini-css-extract-plugin
export default {"Board":"Board_Board__G406h","DarkMode":"Board_DarkMode__+POtE","LightMode":"Board_LightMode__gtGsK"};